<template>
  <!-- About Section -->
  <section class="min-h-screen sm:min-h-full mt-24 sm:mt-10">
    <div id="about">
      <div class="p-5 flex flex-col">
        <div class="mb-20">
          <h2 class="text-center text-5xl font-bold mb-3 sm:mt-10">
            About <span class="text-primary">Me</span>
          </h2>
          <div class="flex flex-col w-1/2 sm:w-1/3 lg:w-1/6 xl:w-44 mx-auto">
            <div
              class="grid h-2 card bg-primary rounded-box place-items-center"
            ></div>
          </div>
        </div>
        <div class="flex flex-col xl:flex-row gap-y-10">
          <div class="text-center w-full">
            <h3 class="text-center font-semibold text-4xl">I'm</h3>
            <p class="mt-5 font-light text-lg lg:text-2xl">
             A Communicative and hard worker person from Bandung. Always try to be a better and better version of myself. Always wanted to learn something new, love web development focusing on backend development, but also learn some frontend web development.
            </p>
          </div>
          <div>
            <h3 class="text-center font-semibold text-4xl">Skills</h3>
            <div class="flex flex-col gap-y-20">
              <div
                class="
                  grid grid-cols-3
                  sm:grid-cols-4
                  gap-x-3 gap-y-5
                  mt-5
                  sm:mt-10
                "
              >
                <a
                  href="https://developer.mozilla.org/en-US/docs/Web/JavaScript"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="@/assets/img/icon/Javascript.svg"
                    alt="Javascript"
                    class="
                      w-20
                      sm:w-1/2
                      lg:w-1/3
                      xl:w-1/2
                      mx-auto
                      transition
                      duration-300
                      ease-in-out
                      transform
                      hover:scale-125
                    "
                    loading="lazy"
                  />
                </a>
                <a
                  href="https://www.typescriptlang.org/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="@/assets/img/icon/Typescript.svg"
                    alt="Typescript"
                    class="
                      w-20
                      sm:w-1/2
                      lg:w-1/3
                      xl:w-1/2
                      mx-auto
                      transition
                      duration-300
                      ease-in-out
                      transform
                      hover:scale-125
                    "
                    loading="lazy"
                  />
                </a>
                <a href="https://www.php.net/" target="_blank" rel="noreferrer">
                  <img
                    src="@/assets/img/icon/PHP.svg"
                    alt="PHP"
                    class="
                      w-20
                      sm:w-1/2
                      lg:w-1/3
                      xl:w-1/2
                      mx-auto
                      transition
                      duration-300
                      ease-in-out
                      transform
                      hover:scale-125
                    "
                    loading="lazy"
                  />
                </a>
                <a
                  href="https://getbootstrap.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="@/assets/img/icon/Bootstrap.svg"
                    alt="Bootstrap"
                    class="
                      w-20
                      sm:w-1/2
                      lg:w-1/3
                      xl:w-1/2
                      mx-auto
                      transition
                      duration-300
                      ease-in-out
                      transform
                      hover:scale-125
                    "
                    loading="lazy"
                  />
                </a>
                <a
                  href="https://materializecss.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="@/assets/img/icon/Materializecss.svg"
                    alt="Materializecss"
                    class="
                      w-32
                      sm:w-3/4
                      lg:w-1/3
                      xl:w-32
                      mx-auto
                      transition
                      duration-300
                      ease-in-out
                      transform
                      hover:scale-125
                    "
                    loading="lazy"
                  />
                </a>
                <a
                  href="https://codeigniter.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="@/assets/img/icon/Codeigniter.svg"
                    alt="Codeigniter"
                    class="
                      w-20
                      sm:w-1/2
                      lg:w-1/3
                      xl:w-1/2
                      mx-auto
                      transition
                      duration-300
                      ease-in-out
                      transform
                      hover:scale-125
                    "
                    loading="lazy"
                  />
                </a>
                <a href="https://laravel.com/" target="_blank" rel="noreferrer">
                  <img
                    src="@/assets/img/icon/Laravel.svg"
                    alt="Laravel"
                    class="
                      w-20
                      sm:w-1/2
                      lg:w-1/3
                      xl:w-1/2
                      mx-auto
                      transition
                      duration-300
                      ease-in-out
                      transform
                      hover:scale-125
                    "
                    loading="lazy"
                  />
                </a>
                <a
                  href="https://nodejs.org/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="@/assets/img/icon/Node.svg"
                    alt="Node"
                    class="
                      w-20
                      sm:w-1/2
                      lg:w-1/3
                      xl:w-1/2
                      mx-auto
                      transition
                      duration-300
                      ease-in-out
                      transform
                      hover:scale-125
                    "
                    loading="lazy"
                  />
                </a>
                <a
                  href="https://expressjs.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="@/assets/img/icon/Express.svg"
                    alt="Express"
                    class="
                      w-20
                      sm:w-1/2
                      lg:w-1/3
                      xl:w-1/2
                      mx-auto
                      transition
                      duration-300
                      ease-in-out
                      transform
                      hover:scale-125
                    "
                    loading="lazy"
                  />
                </a>
                <a href="https://nestjs.com/" target="_blank" rel="noreferrer">
                  <img
                    src="@/assets/img/icon/Nestjs.svg"
                    alt="NestJs"
                    class="
                      w-20
                      sm:w-1/2
                      lg:w-1/3
                      xl:w-1/2
                      mx-auto
                      transition
                      duration-300
                      ease-in-out
                      transform
                      hover:scale-125
                    "
                    loading="lazy"
                  />
                </a>
                <a href="https://vuejs.org/" target="_blank" rel="noreferrer">
                  <img
                    src="@/assets/img/icon/Vue.svg"
                    alt="Vue"
                    class="
                      w-20
                      sm:w-1/2
                      lg:w-1/3
                      xl:w-1/2
                      mx-auto
                      transition
                      duration-300
                      ease-in-out
                      transform
                      hover:scale-125
                    "
                    loading="lazy"
                  />
                </a>
                <a
                  href="https://reactnative.dev/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="@/assets/img/icon/ReactNative.svg"
                    alt="ReactNative"
                    class="
                      w-20
                      sm:w-1/2
                      lg:w-1/3
                      xl:w-1/2
                      mx-auto
                      transition
                      duration-300
                      ease-in-out
                      transform
                      hover:scale-125
                    "
                    loading="lazy"
                  />
                </a>
                <a
                  href="https://www.mysql.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="@/assets/img/icon/Mysql.svg"
                    alt="Mysql"
                    class="
                      w-20
                      sm:w-1/2
                      lg:w-1/3
                      xl:w-1/2
                      mx-auto
                      transition
                      duration-300
                      ease-in-out
                      transform
                      hover:scale-125
                    "
                    loading="lazy"
                  />
                </a>
                <a
                  href="https://www.postgresql.org/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="@/assets/img/icon/Postgres.svg"
                    alt="Postgres"
                    class="
                      w-20
                      sm:w-1/2
                      lg:w-1/3
                      xl:w-1/2
                      mx-auto
                      transition
                      duration-300
                      ease-in-out
                      transform
                      hover:scale-125
                    "
                    loading="lazy"
                  />
                </a>
                <a
                  href="https://www.mongodb.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="@/assets/img/icon/Mongo.svg"
                    alt="Mongo"
                    class="
                      w-20
                      sm:w-1/2
                      lg:w-1/3
                      xl:w-1/2
                      mx-auto
                      transition
                      duration-300
                      ease-in-out
                      transform
                      hover:scale-125
                    "
                    loading="lazy"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- End About Section -->
</template>

<script>
export default {
  name: "About",
};
</script>
